import React, { useState } from 'react';
import SuiteUITabs from '../../../../components/SuiteUiTabs';
import TeamMembersTable from './TeamMembersTable';
import RolesManagement from './RolesManagement';

const UserManagement = () => {
    const UserManagementTabs = [
        { key: 'members', label: 'Team Members', value: 'members' },
        {
            key: 'roles',
            label: 'Manage Roles',
            value: 'roles'
        }
    ];

    const [selected, setSelected] = useState<
        typeof UserManagementTabs[number]['key']
    >(UserManagementTabs[0]['key']);

    return (
        <div>
            <p className='lg:text-ebony text-midnightHaze text-base px-4 lg:px-0'>User Management</p>
            <div className='lg:pt-12 pt-6 mb-2 px-4 lg:px-0 pb-4 lg:border-b border-gray'>
                <SuiteUITabs
                    tabs={UserManagementTabs}
                    activeTab={selected || 'transactions'}
                    setActiveTab={(val) => setSelected(val)}
                />
            </div>

            {selected === 'members' && (
                <TeamMembersTable {...{ setSelected }} />
            )}

            {selected === 'roles' && <RolesManagement />}
        </div>
    );
};

export default UserManagement;
